var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('el-container',{staticClass:"content"},[_c('Menu'),_c('el-container',[_c('el-main',[_c('Bread'),_c('div',{staticClass:"cont"},[_c('router-view')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }